// @ts-nocheck
import React from 'react';

import { Text } from '@crehana/ui';
import { useMe } from '@crehana/web/dist/ReactContexts/AuthContext';

import { useTranslation } from '@crehana/i18n';

import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import {
  trackUserActivity,
  UserActivityEvent,
} from 'Jsx/Analytics/UserActivity';

import MobileList from '../MobileList';

const MobileRecommendedCourses = ({
  items,
  excludedCourseIds,
  isRecommended,
  modelNameUsedInRecommendations,
}) => {
  const { me, loading, error } = useMe();

  React.useEffect(() => {
    if (!loading && !error && isRecommended && items && items.length > 0) {
      const recommendations = items.map(item => item.originalId).join(',');
      const coursesLength = items.map(item => item.originalId).length;

      trackUserActivity({
        event: UserActivityEvent.RECOMMENDATION_VIEW,
        user: me
          ? {
              segment: me.segmentationKey!,
              username: me.username!,
            }
          : undefined,
        data: {
          item_type: 'course',
          recommendations,
          origin: 'shopping_cart',
          model_used: modelNameUsedInRecommendations,
          total_items: coursesLength,
        },
      });
    }
  }, [me, loading, error]);

  const filteredItems = items
    ? items.filter(el => excludedCourseIds.indexOf(el.originalId) === -1)
    : [];

  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  const trackRecommendationPosition = (
    positionSelected: number,
    originalId: number,
  ) => {
    trackUserActivity({
      event: UserActivityEvent.RECOMMENDATION_POSITION_CLICK,
      data: {
        item_id: originalId,
        item_type: 'course',
        recommendations: items.map(item => item.originalId).join(','),
        position_selected: positionSelected,
        origin: 'shopping_cart',
        model_used: modelNameUsedInRecommendations,
      },
    });
  };

  return (
    <div>
      <Text className="mb-24" type="h4" responsive="sm" as="p">
        {t('RECOMMENDED_COURSES')}
      </Text>
      <MobileList
        items={filteredItems}
        origin="Recommended courses section"
        trackRecommendationPosition={trackRecommendationPosition}
      />
    </div>
  );
};

export default MobileRecommendedCourses;
